import cx from 'classnames'
import { useMemo } from 'react'

import { IconButton } from '../../actions/iconButton/IconButton'
import { collectAllPaths } from './helpers'
import type { TreeLeafData, TreeNodeData } from './types'
import { useExpandedPaths } from './useExpandedPaths'

type Props<Leaf extends TreeLeafData> = {
  nodes: TreeNodeData<Leaf>[]
  id: string
  className?: string
}

export const TreeButtons = <Leaf extends TreeLeafData>({
  nodes,
  id,
  className,
}: Props<Leaf>) => {
  const allPaths = useMemo(() => collectAllPaths(nodes), [nodes])
  const { collapseAll, expandAll } = useExpandedPaths(allPaths, id)

  return (
    <div className={cx('flex flex-row gap-x-1', className)}>
      <IconButton onClick={expandAll} iconName="ChevronUpDown" />
      <IconButton onClick={collapseAll} iconName="ChevronDownUp" />
    </div>
  )
}
